import React, { useEffect } from 'react';
import { useSelector, useHistory } from 'umi';
import {
  G_POP,
} from '@gp/constants/const';
import { LEFT_MENU_NAMESPACE } from '@gp/models/gpopLeftMenuList';

export default function IndexPage(props) {
  const { menuList } = useSelector((state) => state?.[LEFT_MENU_NAMESPACE]);
  const history = useHistory();

  useEffect(() => {
    // 先判断当前路由是否是'/',如果是则要根据后端返回的有权限的菜单数据判断，有 优先级按照 /Pipeline/Overview > /Pipeline/ProjectList 来，没有权限 则默认展示 /Globalpedia/Benchmark
    if (props.location.pathname === '/' || props.location.pathname === '/g-pop') {
      let firstAuthRoute = ''; // 第一个有权限的菜单路由
      if (menuList && menuList.length) {
        for (let i = 0, l = menuList.length; i < l; i++) {
          const item = menuList[i];
          /* // 第一个大菜单 固定为 /Globalpedia，所以跳过第一个大菜单，从第二个大菜单开始判断 是否有权限
          if (i > 0 && item.sub_menus && item.sub_menus.length) {
            firstAuthRoute = item.sub_menus[0].assembly_url;
            break;
          } */
          if (item.sub_menus && item.sub_menus.length) {
            firstAuthRoute = item.sub_menus[0].assembly_url;
            break;
          }
        }
      }
      history.replace(G_POP + firstAuthRoute || /* '/Globalpedia/Benchmark' */'/Pipeline/Overview');
    }
  }, []);

  return <></>;
}
